"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeDefs = exports.createAPIRegistry = exports.getRPCTypes = exports.getAPITypes = exports.createInterBtcApi = exports.createSubstrateAPI = exports.createProvider = void 0;
const api_1 = require("@polkadot/api");
const rpc_provider_1 = require("@polkadot/rpc-provider");
const types_1 = require("@polkadot/types");
const definitions = __importStar(require("./interfaces/definitions"));
const interbtc_api_1 = require("./interbtc-api");
const util_1 = require("@polkadot/util");
function createProvider(endpoint, autoConnect) {
    if (/https?:\/\//.exec(endpoint)) {
        return new rpc_provider_1.HttpProvider(endpoint);
    }
    if (/wss?:\/\//.exec(endpoint)) {
        return new rpc_provider_1.WsProvider(endpoint, autoConnect);
    }
    throw new Error(`unknown scheme for ${endpoint}`);
}
exports.createProvider = createProvider;
function createSubstrateAPI(endpoint, autoConnect, noInitWarn) {
    const provider = createProvider(endpoint, autoConnect);
    const types = getAPITypes();
    const rpc = getRPCTypes();
    return api_1.ApiPromise.create({
        provider,
        types,
        rpc,
        noInitWarn: noInitWarn || true,
        // manual definition for transactionPaymentApi.queryInfo until polkadot-js/api can be upgraded
        // TODO: revert when this work is merged: https://github.com/interlay/interbtc-api/pull/672
        runtime: getRuntimeDefs(),
    });
}
exports.createSubstrateAPI = createSubstrateAPI;
function createInterBtcApi(endpoint, network = "mainnet", account, autoConnect) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = yield createSubstrateAPI(endpoint, autoConnect);
        return new interbtc_api_1.DefaultInterBtcApi(api, network, account);
    });
}
exports.createInterBtcApi = createInterBtcApi;
function getAPITypes() {
    return Object.values(definitions).reduce((res, { types }) => (Object.assign(Object.assign({}, res), types)), {});
}
exports.getAPITypes = getAPITypes;
function getRPCTypes() {
    return Object.values(definitions).reduce((res, { providerRpc }) => (Object.assign(Object.assign({}, res), providerRpc)), {});
}
exports.getRPCTypes = getRPCTypes;
function createAPIRegistry() {
    const registry = new types_1.TypeRegistry();
    registry.register(getAPITypes());
    return registry;
}
exports.createAPIRegistry = createAPIRegistry;
const V1_TO_V4_SHARED_PAY = {
    query_fee_details: {
        description: "The transaction fee details",
        params: [
            {
                name: "uxt",
                type: "Extrinsic"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "FeeDetails"
    }
};
const V2_TO_V4_SHARED_PAY = {
    query_info: {
        description: "The transaction info",
        params: [
            {
                name: "uxt",
                type: "Extrinsic"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "RuntimeDispatchInfo"
    }
};
const V3_SHARED_PAY_CALL = {
    query_length_to_fee: {
        description: "Query the output of the current LengthToFee given some input",
        params: [
            {
                name: "length",
                type: "u32"
            }
        ],
        type: "Balance"
    },
    query_weight_to_fee: {
        description: "Query the output of the current WeightToFee given some input",
        params: [
            {
                name: "weight",
                type: "Weight"
            }
        ],
        type: "Balance"
    }
};
function getRuntimeDefs() {
    return {
        TransactionPaymentApi: [
            {
                // V4 is equivalent to V3 (V4 just dropped all V1 references)
                methods: (0, util_1.objectSpread)({}, V3_SHARED_PAY_CALL, V2_TO_V4_SHARED_PAY, V1_TO_V4_SHARED_PAY),
                version: 4
            },
            {
                methods: (0, util_1.objectSpread)({}, V3_SHARED_PAY_CALL, V2_TO_V4_SHARED_PAY, V1_TO_V4_SHARED_PAY),
                version: 3
            },
        ]
    };
}
exports.getRuntimeDefs = getRuntimeDefs;
//# sourceMappingURL=factory.js.map